import { parseCohorts } from 'components/ReportElement'
import { ReportElement as GqlReportElement } from 'gqlTypes'
import { useMemo } from 'react'

const useElementCohortsAndSubgroups = (
  element: GqlReportElement,
  parsedData: any
) => {
  const parsedContent = JSON.parse(element.content || 'null')
  const keyMeasuresChart = element.contentType === 'KeyMeasuresChart'
  return useMemo(() => {
    if (keyMeasuresChart) {
      const elementCohorts = parseCohorts(
        parsedContent.rows[0]?.cohorts || [],
        parsedData.cohortSynonyms
      )
      const elementSubgroups =
        parsedContent.rows[0]?.segmentations.map(
          (s: { name: string }) => s.name
        ) || []
      return [elementCohorts, elementSubgroups]
    } else if (
      element.contentType === 'BarChart' ||
      element.contentType === 'Table'
    ) {
      const elementCohorts = parseCohorts(
        parsedContent.cohorts || [],
        parsedData.cohortSynonyms
      )
      const elementSubgroups: string[] =
        parsedContent.segmentations?.map((s: { name: string }) => s.name) || []
      return [elementCohorts, elementSubgroups]
    } else {
      const dataSourceName = parsedContent.data_source_name
      const elementCohorts = parseCohorts(
        parsedData.elements[dataSourceName]?.cohorts || [],
        parsedData.cohortSynonyms
      )
      const elementSubgroups: string[] =
        parsedData.elements[dataSourceName]?.segmentations?.map(
          (s: { name: string }) => s.name
        ) || []
      return [elementCohorts, elementSubgroups]
    }
  }, [element, parsedData])
}

export default useElementCohortsAndSubgroups
